export const FILTER_TYPES = {
    SINGLE: 'single',
    COMBO: 'combo',
    DATE: 'date',
    NUMBER: 'number',
    FREE_TEXT: 'freeText',
} as const;

export type FilterTypes = (typeof FILTER_TYPES)[keyof typeof FILTER_TYPES];

export type FiltDimension = {
    value: string;
    prefix?: string;
    display: string;
    type: FilterTypes | null;
    disabled?: boolean;
    // options?: string[];
};

export type OldFilterOpt = {
    display: string;
    value: string;
    type?: string;
    fixed?: boolean;
    disabledOnFollowers?: boolean;
};

export type NewFilter = {
    dim: FiltDimension;
    operator?: string;
    value: (string | number)[];
};

export type Filter = { id: number } & NewFilter;

export type FilterCateg = {
    category: string;
    values: FiltDimension[];
};

export type FiltSearchParams = {
    dim: FiltDimension;
    val: string | null;
};

export class NewFilterInit {
    dim = { display: '', value: '', type: null };
    operator = '';
    value = [];
}
